import React from "react";

type ModalProps = {
  onClose: () => void;
  children: React.ReactNode;
};

const Modal: React.FC<ModalProps> = ({ onClose, children }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center">
    {/* Background overlay */}
    <div
      className="absolute inset-0 bg-gray-500 opacity-75"
      onClick={onClose}
      role="button"
      tabIndex={0}
      aria-label="Close modal"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClose();
        }
      }}
    />

    {/* Modal content */}
    <div
      className="relative bg-white rounded-lg p-4 z-50"
      role="dialog"
      aria-modal="true"
    >
      {children}
    </div>
  </div>
);

export default Modal;
